export default {
  setComments(state, comments) {
    state.comments = comments;
  }
};
